export default "__VITE_ASSET__e40167f5__"